<template>
	<div class="hello" id="detailDom">
		<RobotSocket ref="robotSocket" :nowTime='nowTime' @backSockertData='doSocker($event)' />
		<Head type='admin' @tapStatus="changeTap($event)" @out='headOut($event)'></Head>


    <!-- 生产任务切换-->
    <el-dialog :visible.sync="taskVisible" width="30%" center>
      <div style="width: 100%;height: 100%;position: relative;">
        <img style="width: 100%;height: 45vh;" src="../../../static/imgV2/newDialog-7.png" alt="">
        <div class="gifDom">
          <img src="../../../static/imgV2/breathe.gif" alt="">
          <div class="title-top-text">生产任务</div>
        </div>
        <div style="position: absolute;width: 100%;top: 20%;font-size: 0.8vw;color: #c4ddf7;">
          <div style="margin-left: 2%">当前生产状态：&nbsp;{{statusMap[currentOil.currentStatus]}}</div>
          <div style="margin-left: 2%;margin-top: 5%;">生产状态</div>
          <div style="margin-left: 2%;margin-top: 2%;">
            <el-radio-group v-model="selectStatus">
              <el-radio label="1" v-if="currentOil.currentStatus!='1'">调和</el-radio>
              <el-radio label="2" v-if="currentOil.currentStatus!='2'">罐装</el-radio>
              <el-radio label="3" v-if="currentOil.currentStatus!='3'">循环</el-radio>
              <el-radio label="4" v-if="currentOil.currentStatus!='4'">加热</el-radio>
            </el-radio-group>
          </div>
          <div style="margin-left: 2%;margin-top: 5%;">复查情况</div>
          <div style="margin-left: 2%;margin-top: 2%;">
            <el-radio-group v-model="taskType">
              <el-radio label="1">复查</el-radio>
              <el-radio label="2">无需复查</el-radio>
            </el-radio-group>
          </div>
          <div v-if="taskType=='1'" style="margin-left: 2%;margin-top: 2%;">
            <el-select size="mini" v-model="robotValue"  placeholder="请选择机器人" clearable>
              <el-option v-for="(item, $index) in robotList" :key="$index" :label="item.robotName" :value="item.robotId">
              </el-option>
            </el-select>
            机器人在 <el-input-number v-model="num" size="mini" :min="1" :max="20" label="描述文字"></el-input-number>
            分钟后复查。
          </div>
        </div>
        <div
            style="position: absolute;left:10%;width: 80%;bottom: 10%;display: flex;justify-content: space-between;">
          <div class="newBtn1" style="width: 40%;" @click="taskVisible = false">取消</div>
          <div class="newBtn1 newBtn1do" style="width: 40%;" @click="taskConfirm">确认</div>
        </div>
      </div>
    </el-dialog>

    <!-- 操作确认-->
    <el-dialog :visible.sync="confirmVisible" width="30%" center>
      <div style="width: 100%;height: 100%;position: relative;">
        <img style="width: 100%;height: 50%;" src="../../../static/imgV2/newDialog-7.png" alt="">
        <div class="gifDom">
          <img src="../../../static/imgV2/breathe.gif" alt="">
          <div class="title-top-text">操作确认</div>
        </div>
        <div style="position: absolute;width: 100%;top: 1%;font-size: 0.8vw;color: #c4ddf7;">
          <div style="margin-top: 15%;margin-left: 15%;">确认将{{currentOil.oilName}}由【{{statusMap[currentOil.currentStatus]}}】
            状态更改为【{{statusMap[selectStatus]}}】状态吗？
          </div>
          <div v-if="taskType=='1'" style="margin-top: 2%;margin-left: 15%;">机器人【{{robotName}}】将在{{num}}分钟后进行复查</div>
        </div>
        <div
            style="position: absolute;left:10%;width: 80%;bottom: 10%;display: flex;justify-content: space-between;">
          <div class="newBtn1" style="width: 40%;" @click="confirmVisible = false">取消</div>
          <div class="newBtn1 newBtn1do" style="width: 40%;" @click="submitTask">确认</div>
        </div>
      </div>
    </el-dialog>

    <!-- 取消任务-->
    <el-dialog :visible.sync="cancelVisible" width="30%" center>
      <div style="width: 100%;height: 100%;position: relative;">
        <img style="width: 100%;height: 50%;" src="../../../static/imgV2/newDialog-7.png" alt="">
        <div class="gifDom">
          <img src="../../../static/imgV2/breathe.gif" alt="">
          <div class="title-top-text">操作确认</div>
        </div>
        <div style="position: absolute;width: 100%;top: 1%;font-size: 0.8vw;color: #c4ddf7;">
          <div style="margin-top: 18%;margin-left: 28%;">确认取消当前罐体的复查任务吗？
          </div>
        </div>
        <div
            style="position: absolute;left:10%;width: 80%;bottom: 10%;display: flex;justify-content: space-between;">
          <div class="newBtn1" style="width: 40%;" @click="cancelVisible = false">取消</div>
          <div class="newBtn1 newBtn1do" style="width: 40%;" @click="cancelTask">确认</div>
        </div>
      </div>
    </el-dialog>

		<!-- 退出登陆提醒 -->
		<el-dialog :visible.sync="dialogVisible" width="30%" center>
			<div style="width: 100%;height: 100%;position: relative;">
				<img style="width: 100%;height: 50%;" src="../../../static/imgV2/newDialog-7.png" alt="">
				<div class="gifDom">
					<img src="../../../static/imgV2/breathe.gif" alt="">
					<div class="title-top-text">{{ languageJson.OperationTips }}</div>
				</div>
				<div
					style="position: absolute;width: 100%;top: 35%;font-size: 1.2vw;color: white;font-weight: 600;text-align: center;">
					{{ languageJson.ExitText }}</div>
				<div
					style="position: absolute;left:10%;width: 80%;bottom: 10%;display: flex;justify-content: space-between;">
					<div class="newBtn1" style="width: 40%;" @click="dialogVisible = false">{{ languageJson.Cancel }}</div>
					<div class="newBtn1 newBtn1do" style="width: 40%;" @click="getOut()">{{ languageJson.Exit }}</div>
				</div>
			</div>
		</el-dialog>


    <!-- 机器人事件提醒 -->
    <el-dialog :visible.sync="ifShowRobot" width="50%" center :close-on-click-modal="false">
      <div style="width: 100%;height: 100%;position: relative;">
        <EventImgUser @wrong="wrongFun('1', true)" @frontClose="ifShowLeave = true"  :robotInfo="robotInfoEvent" @closeEventImage='ifShowRobot = false'></EventImgUser>
      </div>
    </el-dialog>

    <!-- 事件误识别 -->
    <el-dialog :visible.sync="ifWrong" width="30%" center :close-on-click-modal="false">
      <div class="warningDom">
        <img src="../../../static/imgV2/newDialog-7.png" alt="">
        <div class="gifDom">
          <img src="../../../static/imgV2/breathe.gif" alt="">
          <div class="title-top-text">{{ languageJson.MisidentificationReporting }}</div>
        </div>
        <div class="textarea">
          <div style="margin-bottom: .5vw;">{{ languageJson.BrieflyDescribe }}</div>
          <el-input type="textarea" :rows="3" :placeholder="languageJson.PleaseFillIn" maxlength="200" show-word-limit v-model="remark"></el-input>
        </div>
        <div class="btnDom">
          <div class="newBtn1" style="width: 25%;" @click="ifWrong = false">{{ languageJson.Cancel }}</div>
          <div class="newBtn1 newBtn1do" style="width: 25%;" @click="submitWrong()">{{ languageJson.Submit }}</div>
        </div>
      </div>
    </el-dialog>

		<div class="indeBody">
      <div class="indeBody-left">
        <div class="indeBody-left-item" v-for="(obj, $index) in oilList" :key="$index">
          <div class="indeBody-left-item-oil">{{obj.oilName}}</div>
          <div class="indeBody-left-item-status">
            <span @click="changeStatus(obj)">{{statusMap[obj.currentStatus]}}</span>
          </div>
          <!-- 第一个类别 -->
          <div class="indeBody-left-item-title">
            罐体
          </div>
          <div class="indeBody-left-item-fmbody">
            <div :class="getClass(item.isError)"  v-for="(item, $indexItem) in obj.details.filter(res => res.valveType== '1')">{{item.deviceName}}</div>
          </div>
          <!-- 第二个类别 -->
          <div class="indeBody-left-item-title">
            泵
          </div>
          <div class="indeBody-left-item-fmbody">
            <div :class="getClass(item.isError)"  v-for="(item, $indexItem) in obj.details.filter(res => res.valveType== '2')">{{item.deviceName}}</div>

          </div>
          <!-- 第三个类别 -->
          <div class="indeBody-left-item-title">
            灯箱
          </div>
          <div style="height: 13%" class="indeBody-left-item-fmbody">
            <div :class="getClass(item.isError)"  v-for="(item, $indexItem) in obj.details.filter(res => res.valveType== '3')">{{item.deviceName}}</div>
          </div>

          <div v-if="obj.status=='0' && !obj.delay" class="indeBody-left-item-bottom">
            <div @click="toRecord(obj.oilId)" class="indeBody-left-item-bottom-left">查看记录{{obj.errorNum ? ' ('+ obj.errorNum +')' : '' }}</div>
            <div @click="toDetail(obj.recordId)" class="indeBody-left-item-bottom-right lv">复查中</div>
          </div>

          <div v-if="obj.status=='1' " class="indeBody-left-item-bottom">
            <div @click="toRecord(obj.oilId)" class="indeBody-left-item-bottom-left">查看记录{{obj.errorNum ? ' ('+ obj.errorNum +')' : '' }}</div>
            <div @click="toDetail(obj.recordId)" class="indeBody-left-item-bottom-right lv">复查完成</div>
          </div>

          <div v-if="obj.status=='0' && obj.delay" class="indeBody-left-item-bottom">
            <div @click="toRecord(obj.oilId)" class="indeBody-left-item-bottom-left">查看记录{{obj.errorNum ? ' ('+ obj.errorNum +')' : '' }}</div>
            <div class="indeBody-left-item-bottom-right hui" @click="cancel(obj)"> <Timer :index="$index" :val="obj.delay" @over="overTime" /></div>
          </div>

          <div v-if="!obj.status" class="indeBody-left-item-bottom">
            <div @click="toRecord(obj.oilId)" class="indeBody-left-item-bottom-center">查看记录{{obj.errorNum ? ' ('+ obj.errorNum +')' : '' }} </div>
          </div>

        </div>
      </div>

      <div class="indeBody-right">
        <div class="indeBody-right-title">跑冒滴漏</div>
        <div class="indeBody-right-item" v-for="(item, index) in eventList">
          <img :class="picIndex == index ? 'checkImg' : '' " @click="imgClick(item.eventId,index)" :src="item.picUrl" >
          <div class="indeBody-right-item-name">
            <span>{{item.pointName}}</span>
            <span v-if="item.isError=='1'" style="background: #FC2020">异常</span>
          </div>
          <div class="indeBody-right-item-time">{{item.time}}</div>
        </div>
      </div>
		</div>

	</div>
</template>

<script>
	import RobotSocket from '@/components/RobotSocket.vue'
	import Head from '@/components/Head.vue'
  import Timer from './timer'
  import EventImgUser from '../robotDetail/components/eventImgUser.vue'

	import {
		getRobotEventInfo,
		reportMisIdentification,
    tankList,
    getRobotList,
    issueTasks,
    cancelTask,
    getEventTankList,
	} from '@/api/admin.js'
	import {
		getItem,
		setToken,
		setItem,
		removeItem,
		removeToken
	} from '@/utils/auth'
	import {
		robotDetail,
		mapRoute,
		currentDuty
	} from '@/api/indexV2'
	import {
		groupByDuty,
		controlCommand,
		initialize
	} from '@/api/user.js'
	export default {
		name: 'detail',
		components: {
			Head,
			RobotSocket,
      Timer,
      EventImgUser
		},
		data() {
			return {
			  faceflag:true,
        selectStatus: '1',
        taskType: '1',
        robotValue:null,
        num:5,
        robotName:null,
        robotList:[],
        currentOil:{},
        robotInfoEvent:null,
        picIndex:0,
        ifShowLeave: false,
        ifShowRobot:false,
        evenType: '0',
        ifWrong: false,
        remark: '',
        statusMap:{"1":"调和","2":"灌装","3":"循环","4":"加热"},
        eventList:[],
			  oilList:[],
			  timer:null,
			  flag:'2',
        seconds:12,
				languageJson: languageJson,
				languageCheck: localStorage.getItem('language'),
				vSocketVos: {},
				nowTime: new Date().getTime(),
				tapType: false,
				dialogVisible: false,
        taskVisible:false,
        confirmVisible:false,
        cancelVisible:false,
			}
		},

		mounted() {
      this.getRobotList();
      this.getEventList();
      this.getOilList();
		},

    created() {
    },

    methods: {

		  getOilList(){
        tankList().then(res=>{
          console.log(res)
          this.oilList = res.data;
        })
      },

      getEventList(){
        getEventTankList(getItem('tenantInfoId')).then(res=>{
          console.log(res)
          this.eventList = res.data;
        })
      },

      getRobotList(){
		    getRobotList(getItem('tenantInfoId')).then(res=>{
          console.log(res)
          this.robotList = res.data;
        })
      },

      toRecord(oilId){
        this.$router.push({
          name: 'record',
          query: {
            oilId,
          }
        })
      },

      toDetail(recordId){
        this.$router.push({
          name: 'oilDetail',
          query: {
            recordId,
          }
        })
      },

      cancelTask(){
        console.log(this.currentOil.recordId)
        cancelTask(this.currentOil.recordId).then(res=>{
          this.getOilList();
          this.getRobotList();
          this.cancelVisible = false
          this.$notify.success({
            title: '操作成功'
          })
        })
      },

      submitTask(){

        let param ={
          oilType:this.selectStatus,
          oilId:this.currentOil.oilId,
          delay:this.taskType=='1' ? this.num : null,
          robotId:this.robotValue,
          taskType:this.taskType,
          userId:getItem('userInfo').sName
        }
        console.log(param)
        this.confirmVisible = false
        if(this.faceflag){
          this.faceflag = false;
          issueTasks(param).then(res=>{
            this.faceflag = true;
            this.getOilList();
            this.getRobotList();
            this.$notify.success({
              title: '操作成功'
            })
          })
        }
      },

      taskConfirm(){
        if(!this.robotValue && this.taskType =='1'){
          this.$notify.error({
            title: '请选择机器人'
          })
        }else{
          if(this.taskType=='1'){
            this.robotName = this.robotList.find(res => res.robotId == this.robotValue).robotName;
          }else{
            this.robotName = null;
            this.robotValue = null;
          }
          this.taskVisible = false;
          this.confirmVisible = true;
        }

      },

      cancel(obj){
        this.currentOil = obj;
        this.cancelVisible = true;
      },

      changeStatus(obj){
        if(obj.status){
          this.$notify.error({
            title: '当前罐体已存在复查任务'
          })
          return
        }
        this.selectStatus = '1'
        this.taskType = '1'
        this.robotValue = null;
        this.num = 5;
        this.currentOil = obj;
        this.taskVisible = true
      },

		  imgClick(id,index){
        console.log(index)
		    this.picIndex = index;
        getRobotEventInfo(id).then(res => {
          if (res.data && res.data.imgList.length == 0) {
            this.$notify({
              title: languageJson.noImage,
              type: 'warning'
            })
          } else {
            this.robotInfoEvent = res.data
            this.ifShowRobot = true
          }
        })
        this.ifShowRobot = true
      },

      submitWrong() {
        let that = this
        reportMisIdentification({
          eventId: that.robotInfoEvent.eventId,
          remark: that.remark
        }).then(res => {
          that.ifWrong = false
          that.remark = ''
          that.$notify({
            title: languageJson.SubmitSuccess,
            type: 'success'
          })
        })
      },

      wrongFun(type, state) {
        this.evenType = type
        this.ifWrong = state
      },

      overTime(index){
        this.oilList[index].delay = null;
      },

      getClass(flag){
        let className = "";
        if(flag=="1"){
          className = 'hong'
        }else if(flag=="0"){
          className = 'lv'
        }else{
          className = 'hui'
        }
        return className;
      },

			secondsToTime(seconds) {
				var minutes = Math.floor((seconds) / 60);
				var seconds = seconds - (minutes * 60);
				seconds = Math.round(seconds * 100) / 100;
				var result = (minutes < 10 ? "0" + minutes : minutes) + ":" + (seconds < 10 ? "0" + seconds : seconds);
				return result;
			},

			doSocker(socketData) {

        this.vSocketVos = socketData
				if (socketData.socketType == '30') {
          console.log(socketData)
          this.getOilList()
				}
        if (socketData.socketType == '2') {
          console.log(socketData)
          this.getEventList()
        }
			},

			changeTap(data) {
				this.tapType = data
			},

			headOut(data) {
				this.dialogVisible = true
			},

			getOut() {
				removeToken()
				removeItem('differtime')
				removeItem('loginSuccess')
				this.dialogVisible = false
				this.$router.push({
					name: 'login'
				})
			}
		},
		watch: {
		}
	}
</script>

<style scoped lang="less">
	@import "./index.less";
</style>



// WEBPACK FOOTER //
// src/page/oil/index.vue